<template>
   <a-modal
      title="注册"
      :visible="showvisible"
      cancelText="取消"
      okText="注册"
      :footer="null"
      @cancel="handleCancel"
    >

    <a-form-model ref="Ruleforms" :rules="Ruleforms" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="姓名" prop="name">
       <a-input :maxLength="10" v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item label="手机号" prop="phone">
       <a-input v-model="form.phone" />
      </a-form-model-item>

      <a-form-model-item label="密码" prop="mima">
       <a-input type="password" v-model="form.mima" />
      </a-form-model-item>
      <a-form-model-item label="确认密码" prop="suremima">
       <a-input type="password" v-model="form.suremima" />
      </a-form-model-item>
    </a-form-model>

  <div style="text-align: center;">
    <a-button @click="handleCancel">取消</a-button>
    <a-button type="primary" @click="handleOk" :loading="submitLoading">注册</a-button>
  </div>


    </a-modal>
</template>

<script>
export default {
  props:{
    visible:{
      type:Boolean,
      require:true
    }
  },
  data(){
    //移动电话
    let validateYddh = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9]|17[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (!reg.test(value)) {
        callback(new Error('移动电话格式错误'));
      }else{
        callback();
      }
    }
    let validatemm = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{8,16}$/;
      if (!reg.test(value)) {
        callback(new Error('移动电话格式错误'));
      }else{
        callback();
      }
    }
    return{
      submitLoading:false,

      labelCol: { span: 6 },
      wrapperCol: { span: 14 },

      showvisible:false,

      form:{
        phone:'',
        name:'',
        mima:'',
        suremima:''
      },

      Ruleforms:{
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validateYddh, trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        mima: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, max: 16, validator: validatemm,message: '密码长度需要在8-16位，为数字，字母，特殊字符的组合', trigger: 'blur' },
        ],
        suremima: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 8, max: 16, message: '密码长度需要在8-16位', trigger: 'blur' },
        ],

      }
    }
  },

  mounted(){
    this.showvisible=this.visible
  },

  watch:{
    visible(){
      this.showvisible=this.visible
    }
  },

  methods:{
    handleOk(){
      this.$refs.Ruleforms.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')
        if(this.form.mima!=this.form.suremima)return this.$message.warning('两次密码输入不一致')
      this.submitLoading=true
      this.post({
          url: 'register',
          data:{
            phone:this.form.phone,
            name:this.form.name,
            password:this.form.mima
          }
      }, (res) => {
        this.submitLoading=false
        console.log(res);
        if(res.code!==200) return this.$message.warning(res.data)
        if(res.code===200){
          this.handleCancel()
          console.log(res);
          this.$message.success('注册成功')
        }

      })
      })
    },
    handleCancel(){
      this.showvisible=false
      this.form={
        phone:'',
        mima:'',
        yanzhengma:''
      }
      this.$refs.Ruleforms.resetFields()
      this.$emit('update:visible',false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/sy/compos/regist.vue